import React, { FunctionComponent } from 'react';
import { Button, CustomScrollbar } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';
import sharedStyles from '../my-account-shared.module.scss';
import styles from './product-listing-component.module.scss';

export type ProductListingProps<S extends IListingItemProps<T>, T> = {
  labels?: ILabel[];
  elt: FunctionComponent<S>;
  title: string;
  viewAllUrl?: string;
  isViewAllUrlExternal?: boolean;
  onClickViewAllCallback?: () => void;
  items?: T[];
  onClickItemCallback?: (item: T) => void;
} & Omit<IListingItemProps<T>, 'item' | 'onClickCallback'>;

export type IListingItemProps<T> = {
  tabletWidth: string;
  onClickCallback?: (item: T) => void;
  item: T;
  labels?: ILabel[];
};
export function ProductListing<S extends IListingItemProps<T>, T>({ isViewAllUrlExternal = false, ...props }: ProductListingProps<S, T>) {
  return (
    <div className={styles['product-listing-container']}>
      <div className={styles['title-container']}>
        <p className={sharedStyles.title}>{getLabel(props.labels, props.title)}</p>
        {props.viewAllUrl && (
          <Button
            href={props.viewAllUrl}
            isExternalLink={isViewAllUrlExternal}
            buttonType='link'
            text={getLabel(props.labels, 'view_all')}
            className={styles['view-all-link']}
            onClick={props.onClickViewAllCallback}
          />
        )}
      </div>
      <CustomScrollbar>{getItems()}</CustomScrollbar>
    </div>
  );

  function getItems() {
    return (
      <div className={styles['product-items-container']}>
        {props.items?.map((item) => {
          return React.createElement(props.elt, ({
            tabletWidth: props.tabletWidth,
            onClickCallback: props.onClickItemCallback,
            item: item,
            labels: props.labels,
          } as any) as S);
        })}
      </div>
    );
  }
}

export default ProductListing;
